import { PUBLIC_ASSETS_BASE_URL } from '@app/app-constants'

export const publicAssetPath = (relativePath: string): string => {
  if (!relativePath.startsWith('/')) relativePath = `/${relativePath}`
  return `${PUBLIC_ASSETS_BASE_URL}${relativePath}`
}
